import { defineComponent } from 'vue'
import type { ExtractPropTypes } from 'vue'
import { ElButton } from 'element-plus'


export const edittableCellButtonProps = () => ({
  type: String,
})

export type EdittableCellButtonProps = Partial<ExtractPropTypes<ReturnType<typeof edittableCellButtonProps>>>

export default defineComponent({
  name: 'OEdittableCellButton',
  inheritAttrs: false,
  props: edittableCellButtonProps(),
  emits: ['click'],
  setup(props, { slots, attrs, emit, expose }) {
    const handleClick = (event: Event) => {
      emit('click', event)
    }

    return () => {
      const { type } = props
      const children = slots.default?.()

      return (
        <ElButton link type={type} size="small" onClick={handleClick}>
          {children}
        </ElButton>
      )
    }
  },
})
